<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
>

<style lang="stylus">
#app {
  height: 100vh;
}
</style>
